import { render } from "./StatsWidgetData.vue?vue&type=template&id=6e1fd692&scoped=true"
import script from "./StatsWidgetData.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetData.vue?vue&type=script&lang=ts"

import "./StatsWidgetData.vue?vue&type=style&index=0&id=6e1fd692&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6e1fd692"

export default script